module.exports = __webpack_public_path__ + "img/IgniteDsplogo.74620d0f.png";